import Proxy from '../Proxy';

class StatsOrdersSubscriptionByManagerProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stats/subscription-by-managers', parameters);
  }
}

export default StatsOrdersSubscriptionByManagerProxy;
